<template>
	<router-view />
	<Loader />
</template>

<script>
import Loader from '@/components/Loader.vue';
export default {
	name: 'App',
	components: {
		Loader,
	},
};
</script>
<style lang="scss">
@import '~toastify-js/src/toastify.css';
body {
	margin: 0;
	font-family: 'Inter', sans-serif;
	background: #131313;
	-webkit-tap-highlight-color: transparent;
	outline: none;
}

a {
	text-decoration: none;
}
.mt-20 {
	margin-top: 20px;
}
ul {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.cp {
	cursor: pointer;
}
.toastify {
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
	border-radius: 4px;
	overflow: hidden;

	.toast-close {
		color: #ffffff00;
		position: relative;
		background: none;

		&::after {
			content: url('./assets/icons/close_toast_icon.svg');
			position: absolute;
			right: 4px;
		}
	}
}
.input-style {
	box-sizing: border-box;
	display: flex;
	padding: 10px 0px;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 0px;
	border: 0px solid #80bbff;
	border-bottom: 1px solid #6c6c6c;
	background: #131313;

	caret-color: #fafafa;
	color: #fafafa;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
}

.input-style:-webkit-autofill,
.input-style:-webkit-autofill:hover,
.input-style:-webkit-autofill:focus,
.input-style:-webkit-autofill:active {
	-webkit-box-shadow: 0 0 0 30px #131313 inset !important;
	-webkit-text-fill-color: #fafafa !important;
}

.textarea {
	display: flex;
	padding: 8px 0;
	align-items: flex-start;
	align-self: stretch;
	border: 0px solid #80bbff;
	border-bottom: 1px solid #6c6c6c;
	background: #131313;
	resize: none;
	font-size: 16px;
	line-height: 24px;
	font-weight: 400;
	caret-color: #fafafa;
	color: #fafafa;
	box-sizing: border-box;
}

.input-style:disabled {
	background: rgb(36, 38, 38);
	color: #6c6c6c;
}

.input-style::placeholder {
	color: #6c6c6c;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.4px;
}

.input-style:focus,
textarea {
	outline: none;
}
.textarea::placeholder {
	color: #6c6c6c;
}
.input-style:focus-visible {
	border: 0px solid #80bbff;
	border-bottom: 1px solid #6c6c6c;
}
.label_valid {
	color: #e50914;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px;
	text-align: center;
	display: flex;
	justify-content: center;
	margin-top: 4px;
}
.btn-blue {
	background: #0075ff;
	height: 44px;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 700;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 14px;
	box-sizing: border-box;
}
.btn-red {
	background: #ff0800;
	height: 44px;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 700;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 14px;
	box-sizing: border-box;
}
.btn-white {
	background: #ffffff;
	height: 44px;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 700;
	border: 2px solid #0075ff;
	color: #0075ff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 14px;
	box-sizing: border-box;
}
.label {
	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	color: #80bbff;
}
@font-face {
	font-family: 'Inter';
	src:
		local('Inter'),
		url(./assets/fonts/Inter.ttf) format('truetype');
}
.btn_white {
	color: #131313;
	font-weight: 700;
	font-size: 16px;
	line-height: 19.36px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px 24px;
	border-radius: 61px;
	background: #fafafa;
	cursor: pointer;
	width: fit-content;
	white-space: nowrap;
}
</style>
